__webpack_require__.p = "/book-blog/";